/* @flow */
import { throttle } from 'lodash';
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import { emitter } from 'lib/apollo/emitter';
import ToastActions from 'actions/ToastActions';

const MSG_503 = 'We are currently experiencing some technical issues. Try again later.';

function toast(message: string) {
  ToastActions.showErrorToast(message);
}

const throttledToast = throttle(toast, 2000, { trailing: false });

emitter.on('query_error.401', () => {
  if (CurrentUser.isSignedIn()) {
    console.warn('Received a 401 in GraphQL response. Expiring user session.');
    AuthActions.expireSession();
  }
});

emitter.on('query_error.503', () => throttledToast(MSG_503));
emitter.on('network_error.503', () => throttledToast(MSG_503));
